import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "../auth";
import { formatError } from "../api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await login(email.trim().toLowerCase(), pwd);
      if (r.must_change_password) {
        toast.info("Please change the default password to continue.");
        nav("/admin/change-password", { replace: true });
      } else {
        toast.success("Welcome back.");
        nav("/admin", { replace: true });
      }
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[hsl(var(--aoa-gray-bg))] px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <img src="/logos/aoa_logo_royal_blue.png" alt="AOA Somalia" className="h-16 w-16 object-contain" />
          <h1 className="mt-4 font-display text-2xl font-bold text-[hsl(var(--aoa-navy))]">AOA Admin</h1>
          <p className="mt-1 text-sm text-slate-500">Content Management Studio</p>
        </div>

        <form
          onSubmit={onSubmit}
          className="rounded-2xl border border-slate-200 bg-white p-8 shadow-[0_24px_60px_-24px_rgba(10,31,68,0.18)]"
          data-testid="admin-login-form"
        >
          <label className="block">
            <span className="mb-1.5 inline-block text-xs font-semibold uppercase tracking-[0.12em] text-slate-700">Email</span>
            <input
              type="email"
              required
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="block w-full rounded-lg border border-slate-200 bg-[hsl(var(--aoa-gray-bg))] px-4 py-2.5 text-sm outline-none focus:border-[hsl(var(--aoa-royal))] focus:bg-white"
              placeholder="admin@aoa.so"
            />
          </label>
          <label className="block mt-5">
            <span className="mb-1.5 inline-block text-xs font-semibold uppercase tracking-[0.12em] text-slate-700">Password</span>
            <input
              type="password"
              required
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              data-testid="admin-login-password"
              className="block w-full rounded-lg border border-slate-200 bg-[hsl(var(--aoa-gray-bg))] px-4 py-2.5 text-sm outline-none focus:border-[hsl(var(--aoa-royal))] focus:bg-white"
              placeholder="••••••••"
            />
          </label>
          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="mt-7 w-full inline-flex items-center justify-center gap-2 rounded-lg bg-[hsl(var(--aoa-royal))] py-2.5 text-sm font-semibold text-white hover:bg-[hsl(var(--aoa-navy))] transition-colors disabled:opacity-60"
          >
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
            Sign in
          </button>
          <p className="mt-5 text-center text-xs text-slate-500">
            Authorised personnel only · AOA Somalia
          </p>
        </form>
      </div>
    </div>
  );
}
